import { render, staticRenderFns } from "./ubicacion.vue?vue&type=template&id=81f5b798&scoped=true"
var script = {}
import style0 from "./ubicacion.vue?vue&type=style&index=0&id=81f5b798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f5b798",
  null
  
)

export default component.exports